<!-- No horizontal insets: the element must fill its host container edge-to-edge. -->
<div class="tw:w-full">
  <div class="tw:flex tw:flex-wrap">

    <div class="tw:w-full">
      <ng-template #utilityBarForm>

        <div>

          <div class="desktop-grid">
            <!-- display:contents keeps the switch-off layout exactly as it was; .filter-bar turns it into
                 the grid. Not on .desktop-grid itself: its display:none below 768px must still win. -->
            <div style="display: contents;" [class.filter-bar]="filtersEnabled">
            <!-- Row-level padding, not tw:pr-* on the columns: the unlayered .flex-column global
                 sets its own padding-right and would beat a layered utility. -->
            <div class="flex-row tw:my-4 tw:px-2 filter-bar__group">

              <div class="flex-column tw:md:mr-4 filter-bar__field">
                @if (filtersEnabled) {
                  <label class="field__label">Client Name / ID</label>
                }
                <app-typeahead inputClass="form-control" placeholder="Client Name / Id" [(ngModel)]="searchDataHelper.clientNameOrId" (keydown.enter)="searchPlacements()"
                  data-toggle="tooltip" data-placement="top" title="Please enter the client name or Id"
                  [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch"
                  [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                </div>

                <div class="flex-column filter-bar__field">
                  @if (filtersEnabled) {
                    <label class="field__label">{{themeService.siteContent.placementHeaderLabel}} Identifier</label>
                  }
                  <input class="form-control" type="text" [placeholder]="bookingIdentifierPlaceholder" [(ngModel)]="searchDataHelper.bookingId" (keydown.enter)="searchPlacements()"
                    data-toggle="tooltip" data-placement="top" [title]="bookingIdentifierTooltip">
                  </div>

                  <div class="flex-column tw:md:ml-4 filter-bar__field">
                    @if (filtersEnabled) {
                      <label class="field__label">Search Text</label>
                    }
                    <input class="form-control" [(ngModel)]="searchDataHelper.searchTerm" [placeholder]="searchTextPlaceholder" type="text"
                      (keydown.enter)="searchPlacements()" data-toggle="tooltip" data-placement="top" [title]="searchTextTooltip">
                    </div>

                  </div>

                  <div class="flex-row tw:mt-2 tw:pt-2 tw:mb-4 filter-bar__group">

                    <div class="flex-column tw:pt-2 tw:justify-start tw:items-start tw:pl-2 filter-bar__field filter-bar__field--check">
                      <label class="field__toggle"><input type="checkbox" [(ngModel)]="searchDataHelper.showEnded" /><span class="field__toggle-track"></span> Show Ended</label>
                    </div>

                    <ng-container *appFeatureSwitch="featureKeys.filtersBookingSearch">
                      <div class="flex-column tw:md:ml-4 filter-bar__group">
                        <app-brand-filter class="filter-bar__field" [companyIds]="searchDataHelper.companyIds" (companyIdsChange)="brandsChanged($event)"></app-brand-filter>
                      </div>
                      <div class="flex-column tw:md:ml-4 filter-bar__field" id="bookingSearchFilters">
                        <label class="field__label" for="bookingDeliveryFilter">Delivery</label>
                        <select id="bookingDeliveryFilter" class="form-control" [(ngModel)]="searchDataHelper.deliveryMode"
                          title="Filter by online or in-person delivery">
                          <option [ngValue]="null">All</option>
                          @for (option of deliveryModeOptions; track option.value) {
                            <option [ngValue]="option.value">{{option.label}}</option>
                          }
                        </select>
                      </div>
                      <div class="flex-column tw:md:ml-4 filter-bar__field">
                        <label class="field__label" for="bookingOrderTypeFilter">Order type</label>
                        <select id="bookingOrderTypeFilter" class="form-control" [(ngModel)]="searchDataHelper.provisionType"
                          title="Filter by AP or SP">
                          <option [ngValue]="null">All</option>
                          @for (option of orderTypeOptions; track option.value) {
                            <option [ngValue]="option.value">{{option.label}}</option>
                          }
                        </select>
                      </div>
                      <div class="flex-column tw:md:ml-4 filter-bar__field">
                        <label class="field__label" for="bookingStartFromFilter">Start date from</label>
                        <input id="bookingStartFromFilter" type="date" class="form-control" [(ngModel)]="searchDataHelper.startFrom" (input)="datePreset = null">
                      </div>
                      <div class="flex-column tw:md:ml-4 filter-bar__field">
                        <label class="field__label" for="bookingStartToFilter">Start date to</label>
                        <input id="bookingStartToFilter" type="date" class="form-control" [(ngModel)]="searchDataHelper.startTo" (input)="datePreset = null">
                      </div>
                    </ng-container>

                    @if (!filtersEnabled) {
                      <div class="flex-column tw:md:ml-4 tw:justify-end tw:md:items-end">
                        <button type="submit" class="btn-outline-primary btn tw:ml-1 tw:mr-2 tw:float-right" (click)="searchPlacements()"
                        style="height: 38px; width: 260px;">Search</button>
                      </div>
                    }

                  </div>

                  @if (filtersEnabled) {
                    <div class="filter-bar__actions">
                      <div class="filter-bar__presets">
                        <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                      </div>
                      <div class="filter-bar__buttons">
                        <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                        <button type="submit" class="btn btn-primary" (click)="searchPlacements()">Search</button>
                      </div>
                    </div>
                  }
                  </div>

                </div>

                <div class="mobile-grid">
                  <div style="display: contents;" [class.filter-bar]="filtersEnabled">

                  @if (!externalView) {
                    <div class="flex-row tw:my-4 filter-bar__group">
                      <div class="flex-column filter-bar__field">
                        <label class="filter-bar__label">Client Name / ID</label>
                        <app-typeahead inputClass="form-control" [(ngModel)]="searchDataHelper.clientNameOrId" (keydown.enter)="searchPlacements()"
                          [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch"
                          [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                      </div>
                    </div>
                  }

                  <div class="flex-row tw:my-4 filter-bar__group">
                    <div class="flex-column filter-bar__field">
                      <label class="filter-bar__label">{{themeService.siteContent.placementHeaderLabel}} Identifier</label>
                      <input class="form-control" type="text" [(ngModel)]="searchDataHelper.bookingId" (keydown.enter)="searchPlacements()">
                    </div>
                  </div>

                  <div class="flex-row tw:my-4 filter-bar__group">
                    <div class="flex-column filter-bar__field">
                      <label class="filter-bar__label">Search Text</label>
                      <input class="form-control" [(ngModel)]="searchDataHelper.searchTerm" [placeholder]="searchTextPlaceholder" type="text"
                        (keydown.enter)="searchPlacements()">
                      </div>
                    </div>

                    <ng-container *appFeatureSwitch="featureKeys.filtersBookingSearch">
                      <div class="flex-row tw:my-4 filter-bar__group">
                        <div class="flex-column filter-bar__group">
                          <app-brand-filter class="filter-bar__field" [companyIds]="searchDataHelper.companyIds" (companyIdsChange)="brandsChanged($event)"></app-brand-filter>
                        </div>
                      </div>
                      <div class="flex-row tw:my-4 filter-bar__group">
                        <div class="flex-column filter-bar__field">
                          <label class="filter-bar__label">Delivery</label>
                          <select class="form-control" [(ngModel)]="searchDataHelper.deliveryMode">
                            <option [ngValue]="null">All</option>
                            @for (option of deliveryModeOptions; track option.value) {
                              <option [ngValue]="option.value">{{option.label}}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="flex-row tw:my-4 filter-bar__group">
                        <div class="flex-column filter-bar__field">
                          <label class="filter-bar__label">Order type</label>
                          <select class="form-control" [(ngModel)]="searchDataHelper.provisionType">
                            <option [ngValue]="null">All</option>
                            @for (option of orderTypeOptions; track option.value) {
                              <option [ngValue]="option.value">{{option.label}}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="flex-row tw:my-4 filter-bar__group">
                        <div class="flex-column filter-bar__field">
                          <label class="filter-bar__label">Start date from</label>
                          <input type="date" class="form-control" [(ngModel)]="searchDataHelper.startFrom" (input)="datePreset = null">
                        </div>
                      </div>
                      <div class="flex-row tw:my-4 filter-bar__group">
                        <div class="flex-column filter-bar__field">
                          <label class="filter-bar__label">Start date to</label>
                          <input type="date" class="form-control" [(ngModel)]="searchDataHelper.startTo" (input)="datePreset = null">
                        </div>
                      </div>
                    </ng-container>

                    <div class="flex-row tw:mt-2 tw:pt-2 tw:md:mt-6 tw:md:pt-6 filter-bar__group">
                      <div class="flex-column tw:pt-2 filter-bar__field filter-bar__field--check">
                        <label class="field__toggle"><input type="checkbox" [(ngModel)]="searchDataHelper.showEnded" /><span class="field__toggle-track"></span> Show Ended</label>
                      </div>
                    </div>

                    @if (!filtersEnabled) {
                      <div class="flex-row tw:my-6 tw:pt-4">
                        <div class="flex-column">
                          <button type="submit" class="btn-outline-primary btn tw:mx-1 tw:w-full" (click)="searchPlacements()"
                          style="height: 38px;">Search</button>
                        </div>
                      </div>
                    } @else {
                      <div class="filter-bar__actions">
                        <div class="filter-bar__presets">
                          <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                        </div>
                        <div class="filter-bar__buttons">
                          <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                          <button type="submit" class="btn btn-primary" (click)="searchPlacements()">Search</button>
                        </div>
                      </div>
                    }

                  </div>
                  </div>

                </div>

              </ng-template>
              @if (externalView) {
                <div>
                  <div>
                    <div class="desktop-grid">
                      <div class="flex-row tw:my-4">
                        <div class="flex-column tw:md:mr-4">
                          <input class="form-control" type="text" [placeholder]="bookingIdentifierPlaceholder" [(ngModel)]="searchDataHelper.bookingId" (keydown.enter)="searchPlacements()"
                            data-toggle="tooltip" data-placement="top" [title]="bookingIdentifierTooltip">
                          </div>
                          <div class="flex-column tw:md:ml-4">
                            <input class="form-control" [(ngModel)]="searchDataHelper.searchTerm" [placeholder]="searchTextPlaceholder" type="text"
                              (keydown.enter)="searchPlacements()" data-toggle="tooltip" data-placement="top" [title]="searchTextTooltip">
                            </div>
                          </div>
                          <div class="flex-row tw:mt-2 tw:pt-2 tw:md:mt-6 tw:md:pt-6">
                            <div class="flex-column tw:pt-2 tw:justify-start tw:items-start tw:pl-2">
                              <label class="field__toggle"><input type="checkbox" [(ngModel)]="searchDataHelper.showEnded" /><span class="field__toggle-track"></span> Show Ended</label>
                            </div>
                            <div class="flex-column tw:md:ml-4 tw:justify-end tw:md:items-end">
                              <button type="submit" class="btn-outline-primary btn tw:mx-1 tw:float-right" (click)="searchPlacements()"
                              style="height: 38px; width: 260px;">Search</button>
                            </div>
                          </div>
                        </div>
                        <div class="mobile-grid">
                          @if (!externalView) {
                            <div class="flex-row tw:my-4">
                              <div class="flex-column">
                                <label>Client Name / ID</label>
                                <app-typeahead inputClass="form-control" [(ngModel)]="searchDataHelper.clientNameOrId" (keydown.enter)="searchPlacements()"
                          [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch"
                          [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                              </div>
                            </div>
                          }
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <label>{{themeService.siteContent.placementHeaderLabel}} Identifier</label>
                              <input class="form-control" type="text" [(ngModel)]="searchDataHelper.bookingId" (keydown.enter)="searchPlacements()">
                            </div>
                          </div>
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <label>Search Text</label>
                              <input class="form-control" [(ngModel)]="searchDataHelper.searchTerm" [placeholder]="searchTextPlaceholder" type="text"
                                (keydown.enter)="searchPlacements()">
                              </div>
                            </div>
                            <div class="flex-row tw:mt-2 tw:pt-2 tw:md:mt-6 tw:md:pt-6">
                              <div class="flex-column tw:pt-2">
                                <label class="field__toggle"><input type="checkbox" [(ngModel)]="searchDataHelper.showEnded" /><span class="field__toggle-track"></span> Show Ended</label>
                              </div>
                            </div>
                            <div class="flex-row tw:my-6 tw:pt-4">
                              <div class="flex-column">
                                <button type="submit" class="btn-outline-primary btn tw:mx-1 tw:w-full" (click)="searchPlacements()"
                                style="height: 38px;">Search</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                  </div>

                  <div class="tw:w-full">

                    <!-- Plain divs, not flex-row/flex-column: the unlayered .flex-column global
                         adds 5px top/right/bottom padding, which kept the grid off the card edges. -->
                    <div>
                      <div>
                        <app-data-table
                          [columns]="columns"
                          [data]="searchDataHelper.placements"
                          [serverSide]="true"
                          [totalCount]="totalCount"
                          [pageSize]="pageSize"
                          [sortField]="sortField"
                          [sortDir]="sortDir"
                          [loading]="loading"
                          tableId="placement-search"
                          (pageChange)="onPageChange($event)"
                          (sortChange)="onSortChange($event)"
                          [emptyMessage]="'No ' + themeService.siteContent.placementHeaderLabel + '(s) Found'">

                          <ng-template appColumnCell="client" let-element>
                            {{element.clientName}} ({{element.clientId}})
                          </ng-template>

                          <ng-template appColumnCell="studentGroup" let-element>
                            <div class="student-group-icon-container tw:mr-2 tw:float-left"
                              [ngClass]="{'single-student-icon': !element.isGroup,
                                          'group-one-student-icon': element.isGroup && element.groupSize == 1,
                                          'group-two-student-icon': element.isGroup && element.groupSize == 2,
                                          'group-three-student-icon': element.isGroup && element.groupSize == 3,
                                          'group-multiple-student-icon': element.isGroup && element.groupSize > 3}"></div>
                            <div class="student-group-label">{{element.studentDescription}}</div>
                          </ng-template>

                          <ng-template appColumnCell="actions" let-element>
                            <!-- Tailwind-only column: the buttons must stack at a uniform width. -->
                            <div class="tw:flex tw:flex-col tw:gap-1 tw:py-1">
                              @if (bookingSetupViewPermission) {
                                <button type="button" class="btn btn-primary btn-rounded btn-sm tw:my-0 tw:w-full" (click)="navigateItem(element, 'setup')">Setup</button>
                              }
                              @if (!externalView && tutorReportsViewPermission) {
                                <button type="button" class="btn btn-primary btn-rounded btn-sm tw:my-0 tw:w-full" [ngClass]="{'disabled': element.dotFlag > 0}"
                                  (click)="navigateItem(element, 'reports')" [disabled]="element.dotFlag > 0">Reports</button>
                              }
                            </div>
                          </ng-template>
                        </app-data-table>
                        @if (dotsFound) {
                          <div class="tw:w-full">
                            <label class="tw:ml-4">Status</label>
                            <ul class="tw:w-full" style="list-style-type: none;">
                              <li class="tw:w-full">
                                <div class="pending-dot"></div>
                                <label class="tw:text-danger tw:ml-4">Pending configuration (e.g. assignment of learners, booking configuration, etc.) </label>
                              </li>
                            </ul>
                          </div>
                        }
                      </div>
                    </div>

                  </div>

                </div>
              </div>